import { styled } from "@pp/lib/ui/theme";

const Avatar = styled("img", {
  borderRadius: "$round",
});

export default Avatar;
